import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { ProCard } from '@ant-design/pro-components';
import { Button, Empty, Space } from 'antd';
import React, { useEffect, useRef } from 'react';
import { useSuperDashboardState } from "./Context";
export var SuperDashboardEditor = function SuperDashboardEditor(properties) {
  var lastLayout = useRef(undefined);
  var _useSuperDashboardSta = useSuperDashboardState(),
    _useSuperDashboardSta2 = _slicedToArray(_useSuperDashboardSta, 2),
    environment = _useSuperDashboardSta2[0],
    setEnvironment = _useSuperDashboardSta2[1];
  useEffect(function () {
    if (environment.editing) {
      lastLayout.current = environment.currentLayout;
    }
  }, [environment.editing]);
  return /*#__PURE__*/React.createElement(ProCard, {
    ghost: true
  }, /*#__PURE__*/React.createElement(ProCard, {
    colSpan: {
      xs: 1,
      md: 4
    },
    headerBordered: true,
    bordered: true,
    style: {
      height: '100%'
    },
    bodyStyle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement(Empty, null)), /*#__PURE__*/React.createElement(ProCard, {
    ghost: true,
    direction: "column",
    colSpan: {
      xs: 1,
      md: 20
    }
  }, /*#__PURE__*/React.createElement(ProCard, {
    title: "\u81EA\u5B9A\u4E49\u9996\u9875",
    subTitle: "(\u5DF2\u6DFB\u52A0 0 \u4E2A\u6A21\u5757\uFF0C\u5171\u53EF\u6DFB\u52A0 0 \u4E2A)",
    extra: /*#__PURE__*/React.createElement(Space, null, /*#__PURE__*/React.createElement(Button, {
      type: "text",
      onClick: function onClick() {
        return setEnvironment({
          editing: false,
          currentLayout: lastLayout.current
        });
      }
    }, "\u53D6\u6D88"), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return setEnvironment({
          currentLayout: {
            md: environment.defaultLayout
          }
        });
      }
    }, "\u6062\u590D\u9ED8\u8BA4"), /*#__PURE__*/React.createElement(Button, {
      type: "primary",
      onClick: function onClick() {
        return setEnvironment({
          editing: false
        });
      }
    }, "\u4FDD\u5B58")),
    bordered: true,
    headerBordered: true,
    bodyStyle: {
      display: 'none'
    }
  }), /*#__PURE__*/React.createElement(ProCard, {
    style: {
      backgroundColor: 'transparent'
    },
    bodyStyle: {
      overflow: 'auto',
      height: 'calc(100vh - (2 * 56px) - 68px)'
    }
  }, properties.children)));
};